<template>
  <div class="copy-box">
    <img
      class="copy-image"
      v-if="config.property_data.icon_url"
      :src="config.property_data.icon_url"
    />
    <div v-else>拷贝</div>
    <div
      ref="copyArea"
      :class="['copy-text', { border: isEditorStatus }]"
      :data-clipboard-text="config.property_data.text"
      @click="handleCopy"
      :style="{
        height: config.property_data.height + 'px',
        bottom: config.property_data.bottom + 'px',
      }"
    >
      {{ isEditorStatus ? "可点击区域" : "" }}
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
export default {
  name: "tms-copy-text",
  props: ["config", "isEditorStatus"],
  methods: {
    handleCopy() {
      if (this.isEditorStatus) return;
      const clipboard = new Clipboard(".copy-text");
      clipboard.on("success", (e) => {
        this.$toast(this.config.property_data.copySuccess);
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$toast(this.config.property_data.copyError);
        clipboard.destroy();
      });
    },
  },
};
</script>

<style  lang="scss" scoped>
@import "./index.scss";
</style>